import { useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { getConnectedStations } from "../../services/station";
import BoardView from "./BoardView";
import styles from './QcCheck.module.css';
import SubHeader from "../../components/SubHeader";
import StationSelection from "../../components/StationSelection";

function QcCheck() {
  const {setAvailableLocations, workOrder, currentFactory} = useContext(UserContext);

  useEffect(() => {
    loadData();
  }, [currentFactory.item_code])

  async function loadData() {
    let connectedStations = await getConnectedStations({
      _factory_code: currentFactory.item_code,
      station: "qc"
    });

    setAvailableLocations(connectedStations.message.stations);
  }

  return (
    <div>
      <SubHeader showWorkOrder={true} showSearch={true} showBackButton={false} subTitle={'QC Check'} right={<StationSelection />}></SubHeader>
      <div className="p-24">
        {workOrder && workOrder.id != undefined && <BoardView></BoardView>}
        {(!workOrder || workOrder.id === undefined) && <div className={styles.errorWo}>Kindly search and select workorder to continue QC</div>}
      </div>
    </div>
  );
}

export default QcCheck;
